import { breakpoints } from "@brightagency/headstart-common";
import styled from "styled-components";
import { colors } from "../../../utils/colors";

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    border-radius: 15px;
    padding: 32px 24px;
    background-color: ${colors.brandXXXLight};
    gap: 24px;

    ${breakpoints.large} {
        padding: 40px 60px;
        flex-direction: row;
        gap: 32px;
    }
`;

export const ImageContainer = styled.div`
    flex-shrink: 0;
    width: 100%;
    max-width: 210px;

    img {
        display: block;
        width: 100%;
        height: auto;
    }

    ${breakpoints.large} {
        max-width: 260px;
    }
`;

export const Content = styled.div`
    text-align: center;
    flex-grow: 1;

    ${breakpoints.large} {
        text-align: left;
    }
`;

export const Title = styled.h3`
    font-size: 25px;
    color: ${colors.brandDark};

    ${breakpoints.large} {
        font-size: 32px;
    }
`;

export const ButtonContainer = styled.div`
    width: 100%;
    text-align: center;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    a:last-child {
        color: ${colors.brandDark};
        margin-top: 16px;
    }

    a {
        width: 100%;
        max-width: none;
        font-size: 14px;
    }

    ${breakpoints.medium} {
        max-width: 300px;
    }
`;
